// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.dot[data-v-234efda7] {\n    width: 15px;\n    height: 10px;\n    background-color: white;\n    margin-right: 5px;\n    border-radius: 10px;\n}\n.long-dot[data-v-234efda7] {\n    width: 25px;\n    background-color: #fbde39;\n}\n.highlight[data-v-234efda7] {\n    color: #fbde39;\n}\n.image-div[data-v-234efda7] {\n    height: 250px;\n    display: flex;\n    align-items: center;\n    position: absolute;\n    top: 10;\n    z-index: 1;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
